export default function NewsletterSection() {
  return (
    <section className="bg-secondary-100 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="bg-secondary-50 rounded-3xl p-8 md:p-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100 rounded-full mb-5">
            <i className="ri-whatsapp-line text-accent-500 text-sm"></i>
            <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">Stay in the Loop</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            New Drops, Play Tips &amp; Exclusive Deals
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-8">
            Join the PounceBounce pack! We'll send you the occasional update — product launches, play tips from our vets, and subscriber-only offers. No spam, just the good stuff.
          </p>
          <form
            data-readdy-form
            action="https://readdy.ai/api/form/d8t5e00b9jno5e72bhi0"
            method="POST"
            className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              placeholder="your@email.com"
              required
              className="w-full sm:flex-1 px-5 py-3 rounded-full bg-white border border-secondary-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-300 focus:border-transparent transition-all duration-200"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-accent-500 text-background-50 rounded-full font-bold text-sm hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap"
            >
              Get Updates
            </button>
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hp-field" />
          </form>
        </div>
      </div>
    </section>
  );
}